'use client';

import { useEffect } from 'react';

import type { ApolloError } from '@lichtblick/apollo';

export const useApolloErrorEffect = (
  error: ApolloError | undefined,
  onError: ((apolloError: ApolloError) => void) | undefined,
) => {
  useEffect(() => {
    if (error && onError) {
      onError(error);
    }
  }, [error, onError]);
};
